'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var VideoCamera = function VideoCamera(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 26 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 26 : _ref$width;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-video-camera ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M26,5.53571429 L26,21.3214286 C26,21.6986607 25.7678571,22.0323661 25.4341518,22.1774554 C25.3180804,22.2209821 25.1875,22.25 25.0714286,22.25 C24.8247768,22.25 24.5926339,22.1629464 24.4185268,21.9743304 L18.5714286,16.1272321 L18.5714286,18.5357143 C18.5714286,20.8426339 16.6997768,22.7142857 14.3928571,22.7142857 L4.17857143,22.7142857 C1.87165179,22.7142857 0,20.8426339 0,18.5357143 L0,8.32142857 C0,6.01450893 1.87165179,4.14285714 4.17857143,4.14285714 L14.3928571,4.14285714 C16.6997768,4.14285714 18.5714286,6.01450893 18.5714286,8.32142857 L18.5714286,10.7154018 L24.4185268,4.8828125 C24.5926339,4.69419643 24.8247768,4.60714286 25.0714286,4.60714286 C25.1875,4.60714286 25.3180804,4.63616071 25.4341518,4.6796875 C25.7678571,4.82477679 26,5.15848214 26,5.53571429 Z' })
  );
};

VideoCamera.propTypes = _bcPropTypes.iconShape;

exports.default = VideoCamera;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/VideoCamera/VideoCamera.js
// module id = 343
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15